define('modules/form_editor/views/preview_custom_month',['require','exports','module','./preview_group_base','./preview_custom_month_item','ldsh!../templates/preview_custom_month'],function(require, exports, module){
  "use strict";
  var PreviewGroupBase = require("./preview_group_base"),
      PreviewCustomMonthItem = require("./preview_custom_month_item");
  module.exports = PreviewGroupBase.extend({
    itemView: PreviewCustomMonthItem,
    itemContainer: "select",
    template: require("ldsh!../templates/preview_custom_month")
  });
});

